export class PaymentClass {

    constructor(data){
        this.code = data.code;
        this.amount = data.amount;
        this.description = data.description;
        this.status = data.status;
        this.updated = data.updated;
    }    
}